module.exports = __webpack_public_path__ + "img/Presentation8.35117384.png";